import * as React from 'react';
import * as style from './SubscribeEmail.css';
import { ArticleHeading2, Button, InformationTooltip, Input } from '@cian/ui-kit';
import classNames from 'classnames';
import { ESubscribeStatus } from '../../../common/types/subscribe';

interface ISubscribeEmailProps {
  onClose: VoidFunction;
  onSendMail: () => Promise<void>;
  isMobileDevice: boolean;
  isLoading: boolean;
  fetchMessage: string;
  statusSendMail: ESubscribeStatus;
  refInput: React.MutableRefObject<HTMLInputElement | null>;
}

export const SubscribeEmail: React.FC<ISubscribeEmailProps> = ({
  onClose,
  onSendMail,
  isMobileDevice,
  isLoading,
  fetchMessage,
  statusSendMail,
  refInput,
}) => {
  return (
    <div className={style['container']}>
      <div className={classNames(style['wrapper'], isMobileDevice && style['wrapper-mobile'])}>
        <div className={style['title-container']}>
          <ArticleHeading2 fontWeight="400">
            Хотите быть в курсе новостей рынка недвижимости и получать приглашения на мероприятия от Циан?
          </ArticleHeading2>
        </div>
        <div className={style['form']}>
          <div className={style['label-container']}>
            <ArticleHeading2 color="fill_primary_hover_100" fontWeight="400">
              Подпишитесь на рассылку:
            </ArticleHeading2>
          </div>
          <div className={style['input-group']}>
            <InformationTooltip
              onClose={onClose}
              open={statusSendMail === ESubscribeStatus.Succeed}
              content={fetchMessage}
            >
              <Input
                disabled={isLoading}
                invalid={statusSendMail === 'failed'}
                type="text"
                inputRef={refInput}
                placeholder="Ваш email"
                maxWidth={312}
                size="M"
                minWidth={251}
              />
            </InformationTooltip>
            <div className={style['button-container']}>
              <Button loading={isLoading} theme="fill_primary" size="M" onClick={onSendMail}>
                Подписаться
              </Button>
            </div>
          </div>
          {statusSendMail === 'failed' && <span className={style['notice-error']}>{fetchMessage}</span>}
        </div>
        <div className={style['notice']}>
          Нажимая кнопку, я даю согласие на обработку моих персональных данных в соответствии с{' '}
          <a
            className={style['link']}
            href="https://www.cian.ru/legal-documents/politika_konfidencialnosti_0/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Политикой конфиденциальности.
          </a>
        </div>
      </div>
    </div>
  );
};
